import request from '../../utils/request';

// OVO-206 — collection points ("Caisses") under a Site. A point is a durable
// physical box/container at a Site (1 Site : N points); capacity drives the
// OVO-170 fill-rate suggestions.

export function listCollectionPointsForPartner(partnerId, q) {
  const qs = q ? `?q=${encodeURIComponent(q)}` : '';
  return request(`/partners/${partnerId}/collection-points${qs}`, {
    method: 'GET',
  });
}

export function listCollectionPointsForSite(siteId) {
  return request(`/sites/${siteId}/collection-points`, { method: 'GET' });
}

export function createCollectionPoint(partnerId, data) {
  return request(`/partners/${partnerId}/collection-points`, {
    method: 'POST',
    data,
  });
}

export function updateCollectionPoint(id, data) {
  return request(`/collection-points/${id}`, { method: 'PATCH', data });
}

export function deleteCollectionPoint(id) {
  return request(`/collection-points/${id}`, { method: 'DELETE' });
}

// Partner-viewer read-only (scoped to the caller's own partner via the JWT —
// 404 on another partner's data, OVO-002).
export function getMyCollectionPoints(q) {
  const qs = q ? `?q=${encodeURIComponent(q)}` : '';
  return request(`/partners/me/collection-points${qs}`, { method: 'GET' });
}

export function getMySiteCollectionPoints(siteId) {
  return request(`/partners/me/sites/${siteId}/collection-points`, {
    method: 'GET',
  });
}

// CT prod readiness (Aug 2026) — the dedicated collection-point page.
export function getCollectionPoint(id) {
  return request(`/collection-points/${id}`, { method: 'GET' });
}

export function getCollectionPointStats(id) {
  return request(`/collection-points/${id}/stats`, { method: 'GET' });
}

// #47 — every passage at every box of the partner over a period (YYYY-MM-DD,
// delivery date). One row per (order, box). Admin path carries the driver.
export function getCollectionPointPassages(partnerId, from, to) {
  return request(
    `/partners/${partnerId}/collection-points/passages?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
    { method: 'GET' },
  );
}

// Partner-viewer variant — scoped by the JWT, no driver identity (OVO-002).
export function getMyCollectionPointPassages(from, to) {
  return request(
    `/partners/me/collection-points/passages?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
    { method: 'GET' },
  );
}
